import { Component, Input, OnInit } from '@angular/core';
import { STATUSES } from '../../constants/general-constants';

@Component({
    selector: 'app-status-light',
    templateUrl: './status-light.component.html',
    styleUrls: ['./status-light.component.css'],
    standalone: false
})
export class StatusLightComponent implements OnInit {
  @Input() public value: string;
  @Input() public rowData: any;
  public renderValue: string;
  public statuses = STATUSES;

  constructor() {}

  public ngOnInit() {
    if (this.value) {
      this.renderValue = this.value;
    }
  }
}
